const TopNav = ()=>{


    return (
    <div id="top-nav-container"  className="absolute top-0 h-1 w-0 bg-gradient-to-br from-customyellow to-customdarkblue ">
        <nav  id="top-nav-list-container" className="absolute top-0 left-1/4 bg-gradient-to-br from-customyellow to-customdarkblue  h-12/6 w-2/4 flex justify-center align-middle transform -translate-y-full rounded-bl-lg rounded-br-lg z-1 sm-max:w-full sm-max:top-0 sm-max:left-0">
        
            <ul className="list-none grid grid-flow-row grid-cols-2 gap-3 p-4  w-full overflow-hidden">
                <div className="flex flex-row align-middle ">
                <i className="fas fa-caret-right text-customdarkblue mr-4 px-2 text-lg font-black "></i>    
                <li  className="flex align-middle justify-center px-2 text-lg"><a href="#about" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " >About</a></li>
                </div>
                <div className="flex flex-row align-middle ">
                <i className="fas fa-caret-right text-customdarkblue mr-4 px-2 text-lg font-black "></i>    
                <li className="flex align-middle justify-center px-2 text-lg"><a href="#experience" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Experience</a></li>
                </div>
                <div className="flex flex-row align-middle ">
                <i className="fas fa-caret-right text-customdarkblue mr-4 px-2 text-lg font-black "></i>    
                <li className="flex align-middle justify-center px-2 text-lg"><a href="#builds" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Builds</a></li>
                </div>
                <div className="flex flex-row align-middle ">
                <i className="fas fa-caret-right text-customdarkblue mr-4 px-2 text-lg font-black "></i>    
                <li className="flex align-middle justify-center px-2 text-lg"><a href="#contact" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Contact</a></li>
                </div>
                <div className="flex flex-row align-middle ">
                <i className="fas fa-caret-right text-customdarkblue mr-4 px-2 text-lg font-black "></i>    
                <li className="flex align-middle justify-center px-2 text-lg"><a href="https://yanickndi.herokuapp.com/cv" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Resume</a></li>
                </div>
            </ul>
            
            <div id="top-nav-indicator" className=" flex flex-col justify-center items-center absolute top-0 w-1/4 h-10">
                <span id="burger-1" className="absolute top-1/4 w-8 bg-white h-1 my-1"></span>
                <span id="burger-2" className="absolute top-2/4 w-8 bg-white h-1 my-1"></span>
                <span id="burger-3" className="absolute top-3/4 w-8 bg-white h-1 my-1"></span>
            </div>
        </nav>

    </div>);
};

export default TopNav;